import client from "../libs/HttpClient";

class OurproductServices {
  static ourproductList(request) {
    
    const page_no = request.queryKey[1];
    return client.get(`/ourproduct?page=${page_no}`, request);
  }
  static addOurproduct(request) {
    return client.post(`/add-ourproduct`, request, {});
  }
  static updateOurproduct(request) {
    return client.post(`/edit-ourproduct`, request, {});
  }
  static viewOurproduct(params) {
    return client.get(`get-ourproduct`, { params });
  }
  static deleteOurproduct(params) {
    return client.delete(`delete-ourproduct`, { params });
  }
  static updateStatusOurproduct(request) {
    return client.post(`/ourproduct-status`, request);
  }
}

export { OurproductServices };
